module.exports = __webpack_public_path__ + "static/mehmetcik-web-b49baf9d752eda4e36bcc42e7c666b13.jpg";